import React from 'react'

const PaymentIcon = () => {
  return (
    <div><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3333 5.8335L11.25 12.9168L7.91663 9.5835L1.66663 15.8335" stroke="#DCC5A0" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.3334 5.8335H18.3334V10.8335" stroke="#DCC5A0" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</div>
  )
}

export default PaymentIcon